<template>
  <v-container grid-list-xs>
    <v-row>
      <v-col cols="12">
        <v-form :submit="submitSearch">
          <v-card color="grey-lighten-2">
            <v-card-title>
              Filtro de pesquisa
              <!-- SIM, É ADMIN POIS ESTA VIEW é para ADMINS -->
              <DialogNovoCadastro
                                  :user="user"
                                  :fakeMe="fakeUser_createEditLegalPerson"
                                  @closed="closedDialogNovoCadastro"
                                  @updated="updatedCreateEditLegalPerson"
                                  :admin="true"
                                  :float-right="true"
                                  :dialogStatus="dialogCreateEdit" />
            </v-card-title>
            <v-card-text>
              <v-row density="compact">
                <v-col cols="12">
                  <v-text-field
                                v-model="filters.searchText"
                                label="Nome"
                                clearable
                                density="compact"
                                hide-details></v-text-field>
                </v-col>
                <v-col cols="12" md="3" sm="6">
                  <v-select
                            label="PF/PJ"
                            item-title="label"
                            item-value="value"
                            v-model="filters.is_human"
                            :items="[
                              { label: 'Pessoa Física', value: true },
                              { label: 'Pessoa Jurídica', value: false },
                            ]"
                            clearable
                            density="compact"
                            hide-details></v-select>
                </v-col>
                <v-col cols="12" md="3" sm="6">
                  <v-select
                            label="Tipo de cadastro"
                            item-title="label"
                            item-value="value"
                            v-model="filters.type"
                            :items="personTypes"
                            clearable
                            density="compact"
                            hide-details>
                  </v-select>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="12" md="2">
                  <v-switch v-model="filters.active"
                            :label="filters.active ? 'Ativo' : 'Inativo'"
                            density="compact">
                  </v-switch>
                </v-col>
              </v-row>
              <v-row density="compact">
                <v-spacer></v-spacer>
                <v-col cols="12" md="3" sm="4">
                  <v-select
                            :items="[50, 100, 200, 500]"
                            v-model="filters.itemsPerPage"
                            label="Resultados por página"
                            density="compact"
                            hide-details></v-select>
                </v-col>
              </v-row>
              <v-card-actions>
                <v-btn color="warning" @click="clearFilters()"><v-icon class="mr-2">mdi-broom</v-icon>Limpar
                  pesquisa</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" type="submit"><v-icon class="mr-2">mdi-magnify</v-icon>Pesquisar</v-btn>
              </v-card-actions>
            </v-card-text>
          </v-card>
        </v-form>
      </v-col>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            <v-row>
              <v-col cols="12"> Pessoas / Cadastros </v-col>
              <v-col cols="12">
                <!-- <v-menu>
                  <template v-slot:activator="{ props }">
                    <v-btn
                      color="primary"
                      v-bind="props"
                      style="height: 100%"
                      size="large"
                    >
                      Campos da tabela
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="(item, index) in headers"
                      :key="index"
                      :value="index"
                      @click.stop=""
                    >
                      <v-list-item-title
                        ><v-checkbox
                          :label="item.title"
                          v-model="item.active"
                          hide-details
                          density="compact"
                        ></v-checkbox
                      ></v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu> -->
                <v-select
                          label="Campos da tabela"
                          item-title="title"
                          return-object
                          :items="headers"
                          hide-details
                          multiple
                          clearable
                          chips
                          v-model="selectedHeaders"
                          @update:modelValue="saveSelectedHeaders"></v-select>
              </v-col>
              <!-- <v-col cols="12">
                <v-text-field
                  v-model="searchFilter"
                  append-inner-icon="mdi-magnify"
                  label="Filtrar resultados"
                  clearable
                  single-line
                  hide-details
                ></v-text-field>
              </v-col> -->
            </v-row>
          </v-card-title>
          <v-data-table
                        density="compact"
                        :headers="selectedHeaders"
                        :items="lstUsers"
                        :search="searchFilter"
                        :items-per-page="filters.itemsPerPage"
                        return-object
                        class="elevation-1"
                        hide-default-footer>
            <template v-slot:bottom>
              <div class="text-center pt-2">
                <v-pagination
                              :disabled="requestingApi"
                              v-model="page"
                              :length="maxPage"></v-pagination>
              </div>
            </template>
            <template v-slot:item.is_human="{ item }">
              <span>{{ item.is_human ? "PF" : "PJ" }}</span>
            </template>
            <template v-slot:item.type="{ item }">
              <span>{{
                $LEGAL_PEOPLE_TYPES_DIC[item.type]
                ? $LEGAL_PEOPLE_TYPES_DIC[item.type].label
                : item.type
              }}</span>
            </template>
            <template v-slot:item.created_at="{ item }">
              <span>{{
                $moment(item.created_at).format("DD/MM/YYYY HH:mm")
              }}</span>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-menu>
                <template v-slot:activator="{ props }">
                  <v-btn icon variant="text" v-bind="props"><v-icon>mdi-dots-vertical</v-icon></v-btn>
                </template>
                <v-list>
                  <v-list-item @click="editLegalPerson(item)">
                    <v-list-item-title>
                      <v-icon color="primary" class="mr-2">mdi-pencil</v-icon>
                      Editar Pessoa
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="openTransfer(item)" v-if="user.access_level >= 777">
                    <v-list-item-title>
                      <v-icon class="mr-2">mdi-swap-horizontal</v-icon>
                      Transferir de grupo
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="downloadMedicalRecord(item)"
                               v-if="item.type === $LEGAL_PEOPLE_TYPES_DIC.PADRAO">
                    <v-list-item-title>
                      <v-icon color="secondary" class="mr-2">mdi-file-pdf-box</v-icon>
                      Ficha Medica
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="deleteLegalPerson(item)">
                    <v-list-item-title>
                      <v-icon color="red" class="mr-2">mdi-delete</v-icon>
                      Excluir Cadastro
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <DialogTransferGroup
                         v-model="transferOpen"
                         :person="transferPerson"
                         :user="user"
                         @transferred="onTransferred" />
  </v-container>
</template>
<script>
import AutocompleteSpecialFilters from "@/components/AutocompleteSpecialFilters.vue";
import AutocompleteSelectGroup from "../components/AutocompleteSelectGroup.vue";
import DialogNovoCadastro from "../components/DialogNovoCadastro.vue";
import DialogTransferGroup from "../components/DialogTransferGroup.vue";
import api from '@/services'
export default {
  components: {
    DialogNovoCadastro,
    DialogTransferGroup,
    AutocompleteSelectGroup,
    AutocompleteSpecialFilters,
  },
  props: {
    user: Object,
  },
  data() {
    return {
      requestingApi: false,
      tab: 1,
      headers: [
        { title: "Nome", align: "start", key: "name", sortable: true },
        { title: "Grupo", align: "start", key: "group.acronym", sortable: true },
        { title: "PF/PJ", align: "start", key: "is_human", sortable: true },
        { title: "Tipo", align: "start", key: "type", sortable: true },
        { title: "E-mail", key: "user.email", sortable: true },
        { title: "Data de cadastro", key: "created_at", sortable: true },
        { title: "Ações", key: "actions", align: "end", sortable: false },
      ],
      selectedHeaders: [],
      lstUsers: [],
      filters: {
        withUser: true,
        withGroup: true,
        withSubGroups: true,
        special_filters: [],
        itemsPerPage: 1,
        is_human: null,
        type: 0,
        group_id: null,
        active: true,
      },
      fakeUser_createEditLegalPerson: {},
      dialogCreateEdit: false,
      transferPerson: null,
      transferOpen: false,
      searchFilter: null,
      page: 1,
      maxPage: 1,
    };
  },
  created() {
    var vm = this;
    vm.loadParameters();
  },
  mounted() { },
  activated() { },
  methods: {
    saveSelectedHeaders() {
      var vm = this;
      try {
        localStorage.setItem(
          "_legal_people_list_headers",
          JSON.stringify(vm.selectedHeaders)
        );
      } catch (error) {
        console.error(error);
      }
    },
    selectedGroup(group) {
      var vm = this;
      vm.filters.group_id = group?.id;
    },
    loadParameters() {
      var vm = this;
      let _itemsPerPage = localStorage["_legal_people_itemsPerPage"];
      vm.filters.itemsPerPage = parseInt(_itemsPerPage || 10);

      try {
        let _legal_people_list_headers =
          localStorage["_legal_people_list_headers"];
        vm.selectedHeaders = _legal_people_list_headers
          ? JSON.parse(_legal_people_list_headers)
          : vm.headers;
      } catch (error) {
        vm.selectedHeaders = vm.headers;
      }
    },
    clearFilters() {
      var vm = this;
      vm.filters.searchText = null;
      vm.searchFilter = null;
      vm.filters.special_filters = [];
    },
    submitSearch(page) {
      var vm = this;
      if (!vm.requestingApi) {
        vm.requestingApi = true;
        vm.page = page || 1;
        return new Promise((resolve, reject) => {
          api.legalPerson
            .list(vm.filters, page || 1)
            .then((result) => {
              vm.lstUsers = result?.data;
              vm.maxPage = Math.ceil(
                (result?.total || 1) / (result?.per_page || 10)
              );
              vm.$notify({
                type: "success",
                text: "Pesquisa concluída",
              });
            })
            .catch((err) => {
              if (err.message) {
                vm.$notify({
                  type: "warn",
                  text: err.message,
                });
              }
            })
            .finally(() => {
              vm.requestingApi = false;
            });
        });
      }
    },
    updatedCreateEditLegalPerson(legal_person) {
      var vm = this;
      if (legal_person) {
        if (!vm.fakeUser_createEditLegalPerson?.legal_person?.id) {
          vm.lstUsers.unshift(legal_person);
        }
        vm.fakeUser_createEditLegalPerson = { legal_person };
      }
    },
    closedDialogNovoCadastro() {
      var vm = this;
      vm.fakeUser_createEditLegalPerson = {};
      vm.dialogCreateEdit = false;
    },
    editLegalPerson(legal_person) {
      var vm = this;
      vm.fakeUser_createEditLegalPerson = { legal_person };
      vm.dialogCreateEdit = true;
    },
    openTransfer(item) {
      var vm = this;
      vm.transferPerson = item;
      vm.transferOpen = true;
    },
    onTransferred() {
      var vm = this;
      vm.submitSearch();
    },
    deleteLegalPerson(legal_person) {
      var vm = this;
      let _confirm = confirm("Deseja realmente excluir este cadastro?");
      if (_confirm) {
        vm.requestingApi = true;
        return new Promise((resolve, reject) => {
          api.legalPerson
            .delete(legal_person.id)
            .then(() => {
              let _ix_lp_from = vm.lstUsers.findIndex(
                (x) => x.id === legal_person.id
              );
              vm.lstUsers.splice(_ix_lp_from, 1);
              vm.$notify({
                type: "success",
                text: "Removido com sucesso",
              });
            })
            .catch((err) => {
              if (err.message) {
                vm.$notify({
                  type: "warn",
                  text: err.message,
                });
              }
            })
            .finally(() => {
              vm.requestingApi = false;
            });
        });
      }
    },
    downloadMedicalRecord(legal_person) {
      const vm = this;

      vm.requestingApi = true;
      return new Promise((resolve, reject) => {
        api.pdf
          .downloadPersonMedicalRecord(legal_person.id)
          .then((result) => {
            // create file link inx browser's memory
            const href = URL.createObjectURL(result);

            // create "a" HTML element with href to file & click
            const link = document.createElement('a');
            link.href = href;

            link.setAttribute('download', `FichaMedica_${vm.$moment(new Date()).format("YYYYMMDD-HH-mm-ss")}.pdf`); //or any other extension
            document.body.appendChild(link);
            link.click();

            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link);
            URL.revokeObjectURL(href);
          }).catch((err) => {
            if (err.message) {
              vm.$notify({
                type: "warn",
                text: err.message,
              });
            }
          })
          .finally(() => {
            vm.requestingApi = false;
          });
      });
    },
    // navSelectedGroup() {
    //   var vm = this;
    //   let _group = api.storage.selectedGroup();
    //   console.log('SELECTED GROUP ID ', _group?.id)
    //   return _group?.id || null
    // }
  },
  computed: {
    personTypes() {
      const vm = this;

      return vm.$LEGAL_PEOPLE_TYPES.filter(t => vm.user.access_level >= 777 || t.value !== vm.$LEGAL_PEOPLE_TYPES_DIC.GRUPO);
    }
  },
  watch: {
    "filters.itemsPerPage"(newVal) {
      localStorage["_legal_people_itemsPerPage"] = newVal;
    },
    page(newVal) {
      var vm = this;
      if (!isNaN(newVal)) {
        vm.submitSearch(newVal);
      }
    },
  },
};
</script>